import React, { useEffect, useState } from 'react';

function ProgressBar() {
  const [scrollPercentage, setScrollPercentage] = useState(0);
  const [position, setPosition] = useState('absolute');
  const [scrollMaxValue] = useState(80);
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const handleScroll = () => {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollY = window.scrollY;

    setPosition(window.scrollY > scrollMaxValue ? 'fixed' : 'absolute');

    const scrollPercent = (scrollY / (documentHeight - windowHeight)) * 100;

    setScrollPercentage(scrollPercent);
  };

  return (
    <div
      id="progress-container"
      style={{
        height: '8px',
        width: '100%',
        backgroundColor: '#D9D9D9',
        position: position,
        top: '0',
        left: '0',
        right: '0',
        zIndex: 889,
      }}
    >
      <div
        className="progress-fill"
        style={{
          height: '100%',
          backgroundColor: '#8DC63F',
          width: `${scrollPercentage}%`,
        }}
      ></div>
    </div>
  );
}

export default ProgressBar;
